// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__cAqdo {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.styles_content__SuvYs {
  align-items: center !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.75rem !important;
  padding-top: 1rem !important;
}

.styles_periodRow__3LI9g {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.styles_periodField__jfMt6 {
  flex: 1 1;
}

.styles_field__RAmsD {
  width: 100%;
}

.styles_containerBtn__CghJk {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  margin: 0 !important;
}

.styles_btnCancelar__aXCYt {
  background: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
}

.styles_btnSalvar__ct6mb {
  background: #18316e !important;
  border: 1px solid #18316e !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalSelecaoEmpresa/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":[".title {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.content {\n  align-items: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0.75rem !important;\n  padding-top: 1rem !important;\n}\n\n.periodRow {\n  display: flex;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.periodField {\n  flex: 1;\n}\n\n.field {\n  width: 100%;\n}\n\n.containerBtn {\n  display: flex !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n  margin: 0 !important;\n}\n\n.btnCancelar {\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n}\n\n.btnSalvar {\n  background: #18316e !important;\n  border: 1px solid #18316e !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__cAqdo`,
	"content": `styles_content__SuvYs`,
	"periodRow": `styles_periodRow__3LI9g`,
	"periodField": `styles_periodField__jfMt6`,
	"field": `styles_field__RAmsD`,
	"containerBtn": `styles_containerBtn__CghJk`,
	"btnCancelar": `styles_btnCancelar__aXCYt`,
	"btnSalvar": `styles_btnSalvar__ct6mb`
};
export default ___CSS_LOADER_EXPORT___;
